export function getDirectInnerText(element) {
  const childNodes = element.childNodes;
  let result = '';
  for (let i = 0; i < childNodes.length; i++) {
    if(childNodes[i].nodeType == 3) {
      result += childNodes[i].data;
    }
  }
  return result;
}